import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Typography, MenuItem, Select, IconButton, Paper, Box, Switch, TextField, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Snackbar, Checkbox, ListItemText } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Grid,
    CircularProgress
} from '@mui/material';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TokenError from '../tokenError';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
var constants = require('../../constant');

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const ManagerSettings = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;

    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [openAddManager, setOpenAddManager] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));


    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [adminId, setAdminId] = useState('');
    const [adminName, setAdminName] = useState('');
    const [adminEmail, setAdminEmail] = useState('');
    const [adminPassword, setAdminPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [adminRole, setAdminRole] = useState('');
    const [isActive, setIsActive] = useState(1);
    const [selectedCities, setSelectedCities] = useState([]);
    const [rolesData, setRolesData] = useState([]);
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
    const [selectedAdminId, setSelectedAdminId] = useState('');
    const [selectedAdminEmail, setSelectedAdminEmail] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const currentAdminId = localStorage.getItem('admin_id');
    const currentRoleId = localStorage.getItem('client_role_id');
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [resetConfirmPassword, setResetConfirmPassword] = useState("");

    const [isOldPasswordValid, setIsOldPasswordValid] = useState(false);
    const [checkingOldPassword, setCheckingOldPassword] = useState(false);
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [passwordMatchError, setPasswordMatchError] = useState("");
    const admin_id = localStorage.getItem('admin_id');

    const city_manager_enabled = localStorage.getItem('city_manager_enabled');
    // const admin_id = localStorage.getItem('admin_id');
    useEffect(() => {
        if (!openAddManager){
            const loadDocuments = async () => {
                const data = await fetchManagerData();
                setRows(data); // Set rows with fetched data
            };
            loadDocuments();
        }
        
    }, [openAddManager]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false);
    };

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

  const handleCheckOldPassword = async () => {
    if (!oldPassword) return;

    try {
      setCheckingOldPassword(true);
      setOldPasswordError("");
      const url = operationsUrl + "/admin-panel/verify_old_password";
      const payload = {
        old_password: oldPassword,
        admin_id: selectedAdminId
      };

      const response = await makePostRequestToUrl(url, payload);

      if (response.flag == 200) {
        setIsOldPasswordValid(true);
        setMessage("Old password is correct");
        showSnackbar(true);
      } else {
        setIsOldPasswordValid(false);
        setOldPasswordError("Old password is incorrect");
      }
    } catch (error) {
      setOldPasswordError("Error verifying old password");
      setIsOldPasswordValid(false);
    } finally {
      setCheckingOldPassword(false);
    }
  };

  const handlePasswordChange = (value, type) => {
    if (type === "new") setNewPassword(value);
    if (type === "confirm") setResetConfirmPassword(value);

    if (type === "confirm" || type === "new") {
      const newPass = type === "new" ? value : newPassword;
      const confirmPass = type === "confirm" ? value : resetConfirmPassword;

      if (confirmPass && newPass !== confirmPass) {
        setPasswordMatchError("Passwords do not match");
      } else {
        setPasswordMatchError("");
      }
    }
  };

  const handleResetPassword = async () => {
    try {
      const url = operationsUrl + "/admin-panel/reset_password"
      const payload = {
        password: newPassword,
        email: selectedAdminEmail
      };
      const response = await makePostRequestToUrl(url, payload);

      if (response.flag == 200) {
        setOpenResetPasswordModal(false);
        setMessage("Password reset successfully");
        showSnackbar(true);
        setOldPassword("");
        setNewPassword("");
        setResetConfirmPassword("");
        setIsOldPasswordValid(false);
        setPasswordMatchError("");
        setOldPasswordError("");
      }else{
        setErrorMessage(response.message);
      }

    } catch (error) {
      console.error("Reset failed");
    }
  };

  const isSubmitDisabled =
    // !isOldPasswordValid ||
    !newPassword ||
    !resetConfirmPassword ||
    passwordMatchError;


    const handlresetPasswordmodalclose = () =>{
        setOpenResetPasswordModal(false);
        setOldPassword("");
        setNewPassword("");
        setResetConfirmPassword("");
        setIsOldPasswordValid(false);
        setPasswordMatchError("");
        setOldPasswordError("");
    }

    const handleresetPasswordmodalopen = (row) => {
        setOldPassword("")
        setNewPassword("")
        setResetConfirmPassword("")
        setIsOldPasswordValid(false);
        setPasswordMatchError("");
        setOldPasswordError("");
        setSelectedAdminId(row.id);
        setSelectedAdminEmail(row.email);
        setOpenResetPasswordModal(true);
    }

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'status') setStatusFilter(value);

        setIsFilterApplied(
            Boolean(value) || Boolean(statusFilter)
        );
    };

    const applyOrResetFilter = () => {
        if (isFilterApplied) {
            setStatusFilter('');
            setIsFilterApplied(false);
            const resetDocuments = async () => {
                const data = await fetchManagerData();
                setRows(data);
            };
            resetDocuments();
        } else {
            const filteredRows = rows.filter((document) =>
                (statusFilter ? document.is_active === statusFilter : true)
            );
            setRows(filteredRows);
        }
    };

    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const currentPage = Math.min(page, totalPages - 1); // Avoid invalid page numbers

    const handleOpenAddManager = () => {
        setEditMode(false);
        setSelectedDocument(null);
        setSelectedCities([]); // Reset cities selection
        setOpenAddManager(true);
    };
    
    const handleCloseAddManager = () => {
        setOpenAddManager(false);
    };

    const fetchManagerData = async () => {
        try {
            const token = localStorage.getItem('token');
            const clientId = localStorage.getItem('clientId');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/panel/get_client_roles`;
            const obj={
                token: token, client_id: clientId, timestamp: timestamp
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            
            return response.data|| [];
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchRolesData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_admin_roles';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const fetchedData = response.data;
                setRolesData(fetchedData.filter((role) => role.is_active != 0));
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchRolesData();
    }, []);

    // Function for document details
    const handleViewDetails = (row) => {
        setSelectedDocument({
            id: row.id,
            name: row.admin_name,
            email: row.email,
            is_active: row.is_active,
            role: row.role,
            allowed_cities: row.allowed_cities
        });
        setEditMode(true);
        // Delay setting `openAddDocument` to ensure React processes the previous updates
        setTimeout(() => {
            setOpenAddManager(true);
        }, 0);
    };

    // Populate form fields in edit mode
    useEffect(() => {
        if (editMode && selectedDocument) {
            setAdminId(selectedDocument.id);
            setAdminName(selectedDocument.name);
            setAdminEmail(selectedDocument.email);
            setIsActive(selectedDocument.is_active);
            setAdminRole(selectedDocument.role);
            // Set selected cities from allowed_cities
            if (selectedDocument.allowed_cities) {
                setSelectedCities(Array.isArray(selectedDocument.allowed_cities) 
                    ? selectedDocument.allowed_cities 
                    : selectedDocument.allowed_cities.split(',').map(id => parseInt(id.trim())));
            }
        } else {
            // Reset fields in add mode
            resetFormFields();
        }
    }, [editMode, selectedDocument]);

    // Function to reset form fields
    const resetFormFields = () => {
        setAdminId('');
        setAdminName('');
        setAdminEmail('');
        setIsActive('');
        setAdminRole('');
        setAdminPassword('');
        setConfirmPassword('');
    };

    const deletingManager = (row) => {
        setOpenDeleteConfirmModal(true);
        setSelectedRow(row);
    }

    const handleDeleteManager = async () => {
    try {
        const token = localStorage.getItem('token');

        const payload = {
            token,
            id: selectedRow.id,
            is_active: -1,
            role: selectedRow.role
        };

        const url = operationsUrl + '/panel/create_and_update_client_roles';
        const response = await axios.post(url, payload);

        if (response.data.flag == 200) {
            console.log('Manager deleted successfully');
            const data = await fetchManagerData();
            setRows(data);
            resetFormFields();
            setOpenDeleteConfirmModal(false);
        }
    } catch (error) {
        console.error('Delete failed', error);
    }
};
    
    // Function to handle saving the document
    const handleSubmit = async () => {

        const token = localStorage.getItem('token');

        const payload = {
            token: token,
            role: adminRole,
            is_active: Number(isActive),
            // allowed_cities: selectedCities,
        };

        if(city_manager_enabled == 1){
            payload.allowed_cities = selectedCities;
        }

        // Include `document_id` in the payload if in edit mode
        if (editMode && adminId) {
            payload.id = adminId;
        }

        if (!editMode) {

            if (adminPassword !== confirmPassword) {
                alert("Passwords do not match. Please check your entries.");
                return;
            }

            payload.password = adminPassword;
            payload.admin_name = adminName;
            payload.email = adminEmail;
            payload.password = adminPassword;
            
            // Only include allowed_cities if city_manager_enabled is 1
            if (city_manager_enabled == 1) {
                payload.allowed_cities = selectedCities;
            }
        }

        try {
            const url = operationsUrl + '/panel/create_and_update_client_roles';
            var response = await axios.post(url, payload);

            if(response.data.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }

            if (response.data.flag === 200) {
                console.log('Manager added successfully:', response.data.message);
            } else {
                console.error('Failed to add manager:', response.data.message);
            }
        } catch (error) {
            console.error('Error while saving Manager:', error);
        }

        handleCloseAddManager(); // Close the modal after saving
        fetchManagerData();
    };

    // Reset the form fields
    const handleReset = () => {
        resetFormFields();
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            {/* <Navbar />
            <div className="App">
                <Sidemenu />
                <div className="content"> */}
                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                        Manager Settings
                    </Typography>

                    <Grid container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '2%' }}>
                        {/* Filter controls */}
                        <Grid item>
                            <Select
                                value={statusFilter}
                                onChange={(e) => handleFilterChange('status', e.target.value)}
                                displayEmpty
                                style={{
                                    width: '220px',
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF',
                                }}
                            >
                                <MenuItem value="">Status</MenuItem>
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Inactive">Inactive</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item style={{ marginLeft: '4%' }}>
                            <Button
                                variant="contained"
                                onClick={applyOrResetFilter}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    marginRight: '1px',
                                    backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                {isFilterApplied ? 'Reset Filter' : 'Apply Filter'}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={handleOpenAddManager}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    backgroundColor: '#000000',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                + Add Manager
                            </Button>
                        </Grid>
                    </Grid>

                    {/* Sidebar for AddDocument */}
                    <div
                        style={{
                            position: 'fixed',
                            top: 65,
                            right: openAddManager ? 0 : '-100%',
                            height: '100%',
                            width: '50%',
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                            transition: 'right 0.3s ease-in-out',
                            zIndex: 1000,
                            overflowY: 'auto',
                            padding: 20
                        }}
                    >
                        <Box onClose={handleCloseAddManager} editMode={editMode}>
                            <div style={{ position: 'relative', padding: '40px 0' }}>
                                {/* Close Button Outside the Card */}
                                <IconButton
                                    aria-label="close"
                                    onClick={handleCloseAddManager}
                                    style={{
                                        position: 'absolute',
                                        top: '-15px', // Position it above the Paper component
                                        left: '1px',
                                        color: '#333',
                                        zIndex: 10,
                                    }}
                                >
                                    <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                                </IconButton>
                                <Paper elevation={3}
                                    style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                        backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                    <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                        {editMode ? 'Edit Manager' : 'Add Manager'}
                                    </Typography>

                                    {editMode && (
                                        <div style={{display: 'flex', alignItems: 'center', backgroundColor: '#fff', padding: '10px 20px',
                                            border: '1px solid #E0E0E0', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                            marginBottom: '20px', marginTop: '50px'}}>
                                            <Typography variant="body1" style={{ color: '#4A4A4A' }}>
                                                Manager
                                            </Typography>
                                            <div style={{ display: 'flex', marginLeft: 'auto' }}>
                                                <Button variant="contained"
                                                    onClick={() => setIsActive(1)} // Fixed: Use setIsActive
                                                    style={{backgroundColor: isActive ? '#0DBA78' : '#F4F4F4',
                                                        color: isActive ? '#FFFFFF' : '#9E9E9E',
                                                        textTransform: 'none', borderRadius: '8px 0 0 8px',
                                                        boxShadow: 'none', padding: '6px 16px', minWidth: '80px'}}>
                                                    Enable
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={() => setIsActive(0)} // Fixed: Use setIsActive
                                                    style={{
                                                        backgroundColor: !isActive ? '#D14545' : '#F4F4F4', // Fixed: Use isActive
                                                        color: !isActive ? '#FFFFFF' : '#9E9E9E', textTransform: 'none',
                                                        borderRadius: '0 8px 8px 0', // Rounded on the right side
                                                        boxShadow: 'none', padding: '6px 16px', minWidth: '80px'}}>
                                                    Disable
                                                </Button>
                                            </div>
                                        </div>
                                    )}

                                    <Grid container spacing={2}>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> Admin Name <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Enter Admin Name"
                                                fullWidth
                                                variant="outlined"
                                                value={adminName}
                                                onChange={(e) => setAdminName(e.target.value)}
                                                InputProps={{
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                                disabled={editMode} 
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label={<span> Email <span style={{ color: 'red' }}>*</span></span>}
                                                placeholder="Email"
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                value={adminEmail}
                                                onChange={(e) => setAdminEmail(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#E0E0E0',
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '16px',
                                                    },
                                                }}
                                                disabled={editMode} 
                                            />
                                        </Grid>

                                        {!editMode && (
                                            <>
                                                {/* Password Field */}
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span> Password <span style={{ color: 'red' }}>*</span></span>}
                                                        placeholder="Password"
                                                        fullWidth
                                                        variant="outlined"
                                                        type="password"
                                                        value={adminPassword}
                                                        onChange={(e) => setAdminPassword(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '56px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#E0E0E0',
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: '16px',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Confirm Password Field */}
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label={<span> Confirm Password <span style={{ color: 'red' }}>*</span></span>}
                                                        placeholder="Confirm Password"
                                                        fullWidth
                                                        variant="outlined"
                                                        type="password"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                        InputProps={{
                                                            style: {
                                                                height: '56px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#E0E0E0',
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: '16px',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        )}


                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel id="role-label">Role <span style={{ color: 'red' }}>*</span></InputLabel>
                                                <Select
                                                    labelId="role-label"
                                                    value={adminRole}
                                                    onChange={(e) => setAdminRole(e.target.value)}
                                                    label="Role"
                                                    fullWidth
                                                    sx={{
                                                        height: '56px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#E0E0E0',
                                                        },
                                                    }}
                                                >
                                                    {rolesData.map((role) => (
                                                        <MenuItem key={role.role_id} value={role.role_id}>
                                                            {role.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {city_manager_enabled == 1 && <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel id="city-select-label">Cities</InputLabel>
                                                <Select
                                                    labelId="city-select-label"
                                                    id="city-select"
                                                    multiple
                                                    value={selectedCities}
                                                    label="Cities"
                                                    onChange={(e) => setSelectedCities(e.target.value)}
                                                    renderValue={(selected) => {
                                                        if (!selected || selected.length === 0) return '';
                                                        return selected.map(cityId => {
                                                            const city = cities.find(c => c.city_id === cityId);
                                                            return city ? city.city_name : '';
                                                        }).join(', ');
                                                    }}
                                                >
                                                    {cities && cities.map((city) => (
                                                        <MenuItem key={city.city_id} value={city.city_id}>
                                                            <Checkbox checked={selectedCities.indexOf(city.city_id) > -1} />
                                                            <ListItemText primary={city.city_name} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>}
                                    </Grid>

                                    <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                            sx={{
                                                width: '140px',
                                                height: '50px',
                                                textTransform: 'none',
                                                fontSize: '16px',
                                                backgroundColor: '#0065FF',
                                                color: 'white',
                                            }}
                                        >
                                            {editMode ? 'Update' : 'Save'}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={handleReset}
                                            sx={{
                                                width: '140px',
                                                height: '50px',
                                                textTransform: 'none',
                                                fontSize: '16px',
                                                backgroundColor: '#F0F0F0',
                                                color: '#B0B0B0',
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </Paper>

                            </div>
                        </Box>
                    </div>

                    {/* Manager Settings Table */}
                    <TableContainer className="table-container" style={{ minHeight: '70vh' }}>
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" align="center" className="table-header" style={{ width: '12%' }}>
                                        <TableSortLabel
                                            active={orderBy === 'fleet_id'}
                                            direction={orderBy === 'fleet_id' ? order : 'asc'}
                                            onClick={() => handleRequestSort('fleet_id')}
                                        >
                                            ID
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '20%' }}>Name</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '20%' }}>Email</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '20%' }}>Role</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                                    {currentRoleId ==1 && <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>Reset Password</TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows
                                    .filter((row) => {
                                        const isStatusMatch = statusFilter 
                                            ? (statusFilter === 'Active' ? row.is_active === 1 : row.is_active === 0) 
                                            : true;

                                        return isStatusMatch;
                                    })
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => {

                                        return(
                                            <TableRow key={row.id}>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.admin_name}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.email}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500' }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.role_name}</Typography></TableCell>
                                            <TableCell align="center" sx={{ width: 'auto', minWidth: '100px',gap:'10px',display:'flex' }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleViewDetails(row)}
                                                    sx={{
                                                        backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                        borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                        '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                        '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                    }}>
                                                    
                                                    <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                        <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                                    </svg>
                                                </Button>
                                                {currentAdminId != row.id && currentRoleId == 1 && <Button
                                                    sx={{
                                                        backgroundColor: '#fbf3f0ff',
                                                        color: '#ed3333ff',
                                                        border: '1px solid #ed3333ff',
                                                        borderRadius: '8px',
                                                        minWidth: '40px',
                                                        boxShadow: 'none',
                                                        '&:hover': { backgroundColor: '#ed3333ff', color: 'white' }
                                                    }}
                                                    // onClick={() => handleDeleteManager(row)}
                                                    onClick={() => deletingManager(row)}
                                                >
                                                    <DeleteIcon />
                                                </Button>}
                                            </TableCell>
                                            {currentRoleId == 1 && <TableCell align="center">
                                                <Button
                                                variant="contained"
                                                onClick={() => handleresetPasswordmodalopen(row)}
                                                sx={{
                                                    backgroundColor: "white",
                                                    color: "#d9881eff",
                                                    border: "1px solid #d9881eff",
                                                    textTransform: "none",
                                                    borderRadius: "8px",
                                                    width: "auto", // Or set a specific width
                                                    minWidth: "120px",
                                                    marginBottom: "10px",
                                                    "&:hover": {
                                                    backgroundColor: "#fa8517ff",
                                                    color: "white",
                                                    },
                                                    "&:active": {
                                                    backgroundColor: "#f56a0dff",
                                                    color: "white",
                                                    },
                                                }}
                                                >
                                                Reset Password
                                                </Button>
                                            </TableCell>}
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                        
                        <div className="custom-pagination">
                            <div className="pagination-info">
                                {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                    (page + 1) * rowsPerPage,
                                    rows.length
                                )} of ${rows.length} entries`}
                            </div>
                            <div className="pagination-controls">
                            <button
                                onClick={() => handleChangePage(null, page - 1)}
                                disabled={page === 0}
                                className="pagination-arrow"
                            >
                                <img src={prevIcon} alt="Previous" />
                            </button>
                                <div className="pagination-numbers">
                                    {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                        <button key={index} onClick={() => handleChangePage(null, index)}
                                            className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                            {index + 1}
                                        </button>
                                    ))}
                                </div>
                                <button
                                    onClick={() => handleChangePage(null, page + 1)}
                                    disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                    className="pagination-arrow"
                                >
                                    <img src={nextIcon} alt="Next" />
                                </button>
                            </div>
                        </div>
                    </TableContainer>

                      <Dialog
                                    open={openDeleteConfirmModal}
                                    onClose={() => setOpenDeleteConfirmModal(false)}
                                    aria-labelledby="delete-booking-dialog-title"
                                    aria-describedby="delete-booking-dialog-description"
                                    PaperProps={{
                                        style: {
                                            borderRadius: '12px',
                                            padding: '10px'
                                        }
                                    }}
                                >
                                    <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="delete-booking-dialog-description">
                                            Are you sure you want to delete this manager permanently?
                                            <br/> This cannot be undone.
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                                        <Button 
                                            onClick={() => setOpenDeleteConfirmModal(false)} 
                                            sx={{
                                                color: '#6B7280', 
                                                borderRadius:'8px', 
                                                textTransform:'none',
                                                border: '1px solid #D1D5DB',
                                                '&:hover': {
                                                    backgroundColor: '#F3F4F6',
                                                    borderColor: '#9CA3AF'
                                                }
                                            }}
                                        >
                                            No
                                        </Button>
                                        <Button 
                                            onClick={() => {
                                                handleDeleteManager();
                                                // setOpenDeleteConfirmModal(false);
                                            }} 
                                            color="error"
                                            variant="contained"
                                            sx={{ 
                                                backgroundColor: '#EF4444', 
                                                borderRadius:'8px', 
                                                textTransform:'none',
                                                '&:hover': {
                                                    backgroundColor: '#DC2626'
                                                }
                                            }}
                                            autoFocus
                                        >
                                            Yes
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                        <Dialog
                              open={openResetPasswordModal}
                              onClose={() => setOpenResetPasswordModal(false)}
                              PaperProps={{
                                style: {
                                  borderRadius: "12px",
                                  padding: "10px"
                                }
                              }}
                            >
                              <DialogTitle sx={{ fontWeight: "bold" }}>
                                Reset Password
                              </DialogTitle>
                        
                              <DialogContent>
                                <DialogContentText sx={{ marginBottom: "15px" }}>
                                  Enter your current password to continue.
                                </DialogContentText>
                        
                                {/* Old Password */}
                                {/* <TextField
                                  fullWidth
                                  type="password"
                                  label="Old Password"
                                  margin="normal"
                                  value={oldPassword}
                                  onChange={(e) => {
                                    setOldPassword(e.target.value);
                                    setIsOldPasswordValid(false);
                                  }}
                                  error={!!oldPasswordError}
                                  helperText={oldPasswordError}
                                /> */}
                        
                                {/* <Button
                                  onClick={handleCheckOldPassword}
                                  disabled={!oldPassword || checkingOldPassword}
                                  variant="contained"
                                 style={{
                                        width: '185px',
                                        height: '40px',
                                        marginRight: '1px',
                                        // backgroundColor: isFilterApplied ? '#F5BB19' : '#0065FF',
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                    }}
                                >
                                  {checkingOldPassword ? (
                                    <CircularProgress size={20} />
                                  ) : (
                                    "Verify Old Password"
                                  )}
                                </Button> */}
                        
                                {/* New Password */}
                                <TextField
                                  fullWidth
                                  type="password"
                                  label="New Password"
                                  margin="normal"
                                //   disabled={!isOldPasswordValid}
                                  value={newPassword}
                                  onChange={(e) => handlePasswordChange(e.target.value, "new")}
                                />
                        
                                {/* Confirm Password */}
                                <TextField
                                  fullWidth
                                  type="password"
                                  label="Confirm Password"
                                  margin="normal"
                                //   disabled={!isOldPasswordValid}
                                  value={resetConfirmPassword}
                                  onChange={(e) => handlePasswordChange(e.target.value, "confirm")}
                                  error={!!passwordMatchError}
                                  helperText={passwordMatchError}
                                />
                              </DialogContent>
                        
                              <DialogActions sx={{ paddingBottom: "20px", paddingRight: "20px" }}>
                                <Button
                                  onClick={() => handlresetPasswordmodalclose()}
                                  sx={{
                                    color: "#6B7280",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    border: "1px solid #D1D5DB",
                                    "&:hover": {
                                      backgroundColor: "#F3F4F6",
                                      borderColor: "#9CA3AF"
                                    }
                                  }}
                                >
                                  Cancel
                                </Button>
                        
                                <Button
                                  onClick={handleResetPassword}
                                  variant="contained"
                                  disabled={isSubmitDisabled}
                                  sx={{
                                    backgroundColor: "#0065FF",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#1D4ED8"
                                    }
                                  }}
                                >
                                  Reset Password
                                </Button>
                              </DialogActions>
                            </Dialog>
                {/* </div>
            </div> */}

            <Snackbar
                open={snackbar} 
                autoHideDuration={2000} 
                onClose={handleSnackbarClose} 
                message={message}
            />
        </div>
    );
    
};

export default ManagerSettings